import {useTheme} from "@emotion/react";
import {useFetcher, useLoaderData} from "@remix-run/react";
import {useEffect, useState} from "react";
import CTA from "../../elements/CTA/index.jsx";
import {ConfirmButton} from "../../elements/CTA/styles.js";
import {CheckBox} from "../../elements/CheckBox/index.jsx";
import {ModalInput} from "../../elements/ModalInput/index.jsx";
import {Recaptcha} from "../../elements/Recaptcha/index.jsx";
import TitleUnderlinedAnimated from "../../elements/TitleUnderlinedAnimated/index.jsx";
import LoadingComponent from "../../elements/loading/index.jsx";
import {Text} from "../../elements/text/index.js";
import {theme} from "../../styles/theme.js";
import {saveToLS} from "../../utils/localStorage.js";
import {ERROR, INITIAL_ERRORS, RECAPTCHA_ERROR, SUCCESS} from "../../utils/validation.js";
import {
  EmailWrapper,
  FirstNameWrapper,
  InputContainer,
  LastNameWrapper,
  SuccessContainer,
} from "../NewsLetter/style.js";

export const ModalForm = ({handleClose}) => {
  const {translation, RECAPTCHA_SITE, baseApiUrl, language} = useLoaderData();
  const {breakpoints} = useTheme();
  const {isMobile} = breakpoints;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [checked, setChecked] = useState(false);
  const [captcha, setCaptcha] = useState("");
  const [recaptchaError, setRecaptchaError] = useState("");

  const [validationErrors, setValidationErrors] = useState(INITIAL_ERRORS);
  const [formResponse, setFormResponse] = useState(null);
  const fetcher = useFetcher();

  useEffect(() => {
    if (
      fetcher.state === "loading" &&
      (fetcher?.data?.status === ERROR || fetcher?.data?.status === RECAPTCHA_ERROR)
    ) {
      if (fetcher?.data?.status === RECAPTCHA_ERROR) {
        setValidationErrors({...INITIAL_ERRORS});
        return setRecaptchaError(fetcher.data.error);
      }
      return setValidationErrors({...INITIAL_ERRORS, ...fetcher.data.errors});
    }
    if (fetcher?.data?.status === SUCCESS) {
      setRecaptchaError("");
      setValidationErrors(INITIAL_ERRORS);
      saveToLS("formSubmitted", "true");
      setFormResponse(
        translation?.nlSuccessText || "Merci, votre inscription est confirmée !",
      );
      setTimeout(() => handleClose(), 6000);
    }
  }, [fetcher.state]);

  function handleSubmit(event) {
    event.preventDefault();
    if (!confirm) {
      return;
    }
    const form = event.currentTarget;
    const formData = new FormData(form);
    formData.set("_action", "newsLetter");
    formData.set("API_BASE_URL", baseApiUrl);
    formData.set("accepted", checked);
    formData.set("recaptchaValue", captcha);

    fetcher.submit(formData, {
      method: "post",
      navigate: false,
    });
  }
  return (
    <fetcher.Form
      onSubmit={handleSubmit}
      style={{
        gridColumn: isMobile ? "1/-1" : "2/10",
        marginTop: 64,
        marginBottom: 64,
        marginInline: isMobile && 16,
      }}
      method={"post"}
    >
      <TitleUnderlinedAnimated wrapperStyles={{marginBottom: 24}}>
        {translation?.nlHeader}
      </TitleUnderlinedAnimated>

      <Text type={"textLarge"}>{translation?.nlSubtitle}</Text>
      <InputContainer>
        <FirstNameWrapper>
          <ModalInput
            name={"firstName"}
            value={firstName}
            onChange={setFirstName}
            error={validationErrors.firstName}
            placeholder={translation?.nlFirstName}
          />
        </FirstNameWrapper>

        <LastNameWrapper validationErrors={validationErrors}>
          <ModalInput
            name={"lastName"}
            value={lastName}
            error={validationErrors.lastName}
            onChange={setLastName}
            placeholder={translation?.nlLastName}
          />
        </LastNameWrapper>
        <EmailWrapper validationErrors={validationErrors}>
          <ModalInput
            name={"email"}
            value={email}
            onChange={setEmail}
            error={validationErrors.email}
            placeholder={translation?.nlEmail}
          />
        </EmailWrapper>
        {confirm && (
          <CheckBox
            checked={checked}
            translation={translation}
            errorAbove={!!validationErrors.email}
            error={validationErrors.accepted}
            setChecked={setChecked}
          />
        )}
        {confirm && (
          <Recaptcha
            sitekey={RECAPTCHA_SITE}
            error={recaptchaError}
            setCaptcha={setCaptcha}
          />
        )}
      </InputContainer>
      {fetcher.state === "submitting" ? (
        <div style={{marginTop: 32}}>
          <LoadingComponent width={40} height={40} />
        </div>
      ) : (
        <>
          {formResponse ? (
            <SuccessContainer>
              <div style={{gridColumn: "1/6"}}>
                <Text type={"titleExtraSmall"}>{formResponse}</Text>
              </div>
            </SuccessContainer>
          ) : (
            <ConfirmButton
              onClick={() => {
                if (!confirm) {
                  setTimeout(() => setConfirm(true), 0);
                }
              }}
              type={"submit"}
            >
              <CTA
                disableLink={true}
                type={"primary"}
                size={isMobile ? "small" : "medium"}
                buttonColor={theme?.colors?.brandBlue}
              >
                {translation?.nlButton}
              </CTA>
            </ConfirmButton>
          )}
        </>
      )}
    </fetcher.Form>
  );
};
